<template>
  <div
    v-if="roamingTeam"
    class="grid"
  >
    <div class="container">
      <Toolbar class="mt-2 mb-2">
        <template #start>
          <h2>{{ $t("nav.roamingTeamDetail") }}</h2>
        </template>

        <template #end>
          <Button
            :label="$t('action.back')"
            icon="pi pi-arrow-left"
            class="p-button-secondary p-button-rounded p-button-outlined"
            @click="toRoamingTeamTable"
          />
        </template>
      </Toolbar>

      <Panel>
        <template #header>
          <p class="font-bold">
            {{ $t('roamingteampagedetailpage.fieldset.roamingteam') }}
          </p>
        </template>
        <div class="card_details ">
          <div class="card_body">
            <ul class="flex justify-content-between">
              <li>
                <div class="address">
                  <ul>
                    <li>{{ $t('entity.roamingTeam.name') }} : <strong>{{ roamingTeam.name }}</strong></li>

                    <li>
                      {{ $t('entity.roamingTeam.availabilityStartDate') }} :
                      <strong class="font-bold data"> {{ roamingTeam.availabilityStartDate }}</strong>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <ul>
                  <li>
                    {{ $t('entity.roamingTeam.state') }} : <strong>{{
                      roamingTeam.enabled ? $t('entity.roamingTeam.active') : $t('entity.roamingTeam.inactive')
                    }}</strong>
                  </li>
                  <li>
                    {{ $t('entity.roamingTeam.availabilityEndDate') }} :
                    <strong class="font-bold data"> {{ roamingTeam.availabilityEndDate }}</strong>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </Panel>

      <Panel class="mt-3 mb-3">
        <template #header>
          <p class="font-bold">
            {{ $t('entity.roamingTeam.planning') }}
          </p>
        </template>

        <div class="p-datatable p-component p-datatable-responsive-scroll p-datatable-striped mt-3">
          <div class="p-datatable-wrapper">
            <table class="p-datatable-table">
              <thead class="p-datatable-thead">
                <tr>
                  <th
                    v-for="col of columns"
                    :key="col.field"
                  >
                    {{ col.header }}
                  </th>
                </tr>
              </thead>
              <tbody class="p-datatable-tbody">
                <tr>
                  <td
                    v-for="col of columns"
                    :key="col.field"
                  >
                    <div
                      v-if="roamingTeam.planning[col.field]"
                      :set="dayPlanning = roamingTeam.planning[col.field]"
                    >
                      <p>
                        {{ $t('entity.planning.from') }} <strong> {{ timeFormat(dayPlanning.availabilityStartTime) }}</strong>
                        {{ $t('entity.planning.to') }} <strong>{{ timeFormat(dayPlanning.availabilityEndTime) }}</strong>
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Panel>
    </div>
  </div>
</template>

<script>
import Panel from "primevue/panel";
import Toolbar from "primevue/toolbar";
import Button from "primevue/button";
import moment from "moment";

export default {
  name: 'RoamingTeamDetail',
  components: {Panel, Toolbar, Button},
  data() {
    return {
      roamingTeam: null,
    }
  },
  computed: {
    columns() {
      return [
        {field: 'mondayPlanning', header: this.$t('entity.planning.monday')},
        {field: 'tuesdayPlanning', header: this.$t('entity.planning.tuesday')},
        {field: 'wednesdayPlanning', header: this.$t('entity.planning.wednesday')},
        {field: 'thursdayPlanning', header: this.$t('entity.planning.thursday')},
        {field: 'fridayPlanning', header: this.$t('entity.planning.friday')},
        {field: 'saturdayPlanning', header: this.$t('entity.planning.saturday')},
        {field: 'sundayPlanning', header: this.$t('entity.planning.sunday')}
      ]
    }
  },
  async mounted() {
    try {
      this.roamingTeam = await this.$roamingTeamService.fetchById(this.$route.params.id)
      if (!this.roamingTeam) await this.$router.push("/roamingTeam")
    } catch (error) {
      this.$emitter.emit('toast', {
        severity: 'error',
        message: error.response.data.map(error => this.$t(error)).join(', ')
      })
      await this.$router.push("/roamingTeam")
    }
  },
  methods: {
    timeFormat(time) {
      return moment(time, 'HH:mm:ss').format('HH:mm')
    },
    toRoamingTeamTable() {
      this.$router.push({ name: 'roamingTeam' })
    }
  }
}
</script>

<style lang="scss" scoped>
span {
  float: right;
}

.card_details {
  span {
    float: none;
  }

  ul,
  ol {
    list-style: none;
    padding: 0;
  }

  .card_header {
    .card_times {
      background: #f7f7f7;
      padding: 10px;
      font-weight: 600;
    }
  }

  .card_body {
    li {
      width: 25vw;
      padding: 5px 0;
    }

  }
}

::v-deep(div.p-panel-header) {
  padding: 0 1rem;
}

::v-deep(div.p-panel-content) {
  padding: 0.1rem 1rem;
}
</style>
